import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
import { NotificationProvider } from './context/NotificationContext';
import { WbRouteProvider } from './wb-preview/WbRouteContext';

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
        <WbRouteProvider routePrefix="">
          <AppRouter />
        </WbRouteProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;
